import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthComponent } from './auth.component';

import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatIconModule } from '@angular/material/icon';
import { AuthDialogComponent } from './components/auth-dialog/auth-dialog.component';
import { ExternalLoginComponent } from './components/auth-dialog/external-login/external-login.component';
import { ForgotPasswordComponent } from './components/auth-dialog/forgot-password/forgot-password.component';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { ReactiveFormsModule } from '@angular/forms';
import { AdRedirectComponent } from './ad-redirect/ad-redirect.component';
import { AdAuthDialogComponent } from './components/ad-auth-dialog/ad-auth-dialog.component';
import { SafeUrlPipe } from './pipes/safe-url.pipe';

@NgModule({
    declarations: [
        AuthComponent,
        AuthDialogComponent,
        ExternalLoginComponent,
        ForgotPasswordComponent,
        AdRedirectComponent,
        AdAuthDialogComponent,
        SafeUrlPipe
    ],
    imports: [
        FormsModule,
        CommonModule,
        MatInputModule,
        MatButtonModule,
        MatProgressSpinnerModule,
        MatIconModule,
        ReactiveFormsModule,
        MatDialogModule,
        MatFormFieldModule,
    ],
    providers: [MatDialog],
})
export class AuthModule { }
